import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    this.form = this.element;

    const raw = this.form.dataset.autoDisplay;
    this.autoDisplay = raw ? JSON.parse(raw) : {};

    this.autoDisplayWatchFieldNames = [
      ...new Set(
        Object.entries(this.autoDisplay)
          .map(([_k, v]) => v.watch)
          .flat()
      ),
    ];

    this._handlers = [];

    for (const field of Array.from(this.form.elements)) {
      if (this.autoDisplayWatchFieldNames.includes(field.name)) {
        const handler = () => this.autoDisplayChanged(field);
        field.addEventListener('input', handler);
        field.addEventListener('change', handler);
        this._handlers.push([field, handler]);
      }
    }
  }

  disconnect() {
    for (const [field, handler] of this._handlers || []) {
      field.removeEventListener('input', handler);
      field.removeEventListener('change', handler);
    }
    this._handlers = [];
  }

  autoDisplaySanitizer(value) {
    if (value == null || value === '') {
      return null;
    } else if (typeof value === 'string') {
      return value.toLowerCase();
    } else {
      return value;
    }
  }

  autoDisplayChanged(field) {
    const formData = new FormData(this.form);

    Object.entries(this.autoDisplay).forEach(([target, config]) => {
      const targetElement = document.getElementById(target);

      if (config.watch.includes(field.name) || field == null) {
        const existingCombination = config.combinations.find((combi) => {
          return Object.entries(combi.required).every(([fieldName, fieldValue]) => {
            let existingVal = formData.get(fieldName);
            return this.autoDisplaySanitizer(existingVal) === this.autoDisplaySanitizer(fieldValue);
          });
        });

        if (existingCombination) {
          targetElement.value = existingCombination.result;
          targetElement.dispatchEvent(new Event('input', { bubbles: true }));
          if (target === 'price') {
            const priceSubTargetElement = document.getElementById('total_price_before_subsidy');
            if (priceSubTargetElement) {
              priceSubTargetElement.value = existingCombination.original;
              priceSubTargetElement.dispatchEvent(new Event('input', { bubbles: true }));
            }
          }
        } else {
          targetElement.value = null;
          targetElement.dispatchEvent(new Event('input', { bubbles: true }));
        }
      }
    });
  }
}
